<script>
import Header from '../../components/header-top-fix';
// import BreadCrumb from '../../components/bread-crumb-blue'
import BeritaDetailWrapper from '../../components/sections/berita-detail-wrapper-3';
import BrandCarousel from '../../components/brand-carousel';
import Footer from '../../components/footer-orange';
import OffCanvasMobileMenu from '@/components/off-canvas-mobile-menu-orange';

export default {
  props: ['dataMeta'],
  components: {
    Header,
    BeritaDetailWrapper,
    BrandCarousel,
    Footer,
    OffCanvasMobileMenu,
  },
  data() {
    return {
      items: [
        {
          text: 'Home',
          to: '/',
        },
        {
          text: 'Berita',
          active: true,
        },
      ],
    };
  },
  metaInfo() {
    return {
      title: `${this.dataMeta.name} - Detil Berita`,
      htmlAttrs: {
        lang: 'en',
        amp: true,
      },
    };
  },
};
</script>
<template>
  <div class="main-container">
    <Header :meta="dataMeta" />

    <BeritaDetailWrapper />

    <Footer bgFooter="old-blue-bg" :meta="dataMeta" />

    <OffCanvasMobileMenu :meta="dataMeta" />

    <!-- back to top start -->
    <back-to-top class="scroll-top-orange" bottom="60px">
      <i class="ion-android-arrow-up"></i>
    </back-to-top>
    <!-- back to top end -->
  </div>
</template>
